import React from "react";
import "./WorkoutForm.css";

const WorkoutForm = ({
  workoutData,
  handleInputChange,
  selectedDays,
  handleDayClick,
  weeks,
  CreateWork,
  EditWork,
  isdisable,
  wid,
  handleImageFileChange,
  selectedimage,
  image,
  placholder,
  getImageUrl,
  BASE_URL_MEDIA,
  selectedVideoUrl,
  workoutVideo,
  handleDivClick,
  fileInputRef,
  handleSelectVideo,
  isUpLoading,
  progress,
  ProgressBar,
}) => {
  const [scheduleType, setScheduleType] = React.useState(
    workoutData.schedule_type  || 'fixed'
  );

  React.useEffect(() => {
    if (!workoutData.schedule_type) {
      console.log("name:", workoutData.name);
      console.warn('Warning: workoutData.schedule_type is missing. Defaulting to "fixed".');
    }
    setScheduleType(workoutData.schedule_type === 'recurring' ? 'recurring' : 'fixed');
  }, [workoutData.schedule_type]);

  const buttons = [
    { id: 1, value: "Sunday", label: "Sunday" },
    { id: 2, value: "Monday", label: "Monday" },
    { id: 3, value: "Tuesday", label: "Tuesday" },
    { id: 4, value: "Wednesday", label: "Wednesday" },
    { id: 5, value: "Thursday", label: "Thursday" },
    { id: 6, value: "Friday", label: "Friday" },
    { id: 7, value: "Saturday", label: "Saturday" },
  ];

  const handleScheduleTypeChange = (type) => {
    setScheduleType(type);
    // Update workoutData with correct key
    handleInputChange({
      target: {
        name: 'schedule_type',
        value: type
      }
    });
  };

  return (
    <div className="pw_workout-form">
      <div className="pw_form-header">
        <h1 className="pw_form-title">
          {isdisable && !wid ? "Create Workout" : "Update Workout"}
        </h1>
        <p className="pw_form-subtitle">
          Design your perfect workout with our intuitive form
        </p>
      </div>

      <div className="pw_form-content">
        {/* Basic Information */}
        <div className="pw_form-row">
          <div className="pw_form-group">
            <label className="pw_form-label">Workout Title</label>
            <input
              type="text"
              name="name"
              className="pw_form-input"
              value={workoutData.name}
              onChange={handleInputChange}
              placeholder="Enter workout name..."
            />
          </div>
          
          <div className="pw_form-group">
            <label className="pw_form-label">Duration (minutes)</label>
            <input
              type="number"
              name="duration"
              className="pw_form-input"
              value={workoutData.duration}
              onChange={handleInputChange}
              placeholder="30"
              min="1"
            />
          </div>
        </div>

        <div className="pw_form-row">
          <div className="pw_form-group">
            <label className="pw_form-label">Workout Type</label>
            <select
              name="workout_type"
              className="pw_form-select"
              value={workoutData.workout_type}
              onChange={handleInputChange}
            >
              <option value="">Select workout type...</option>
              <option value="AMRAP">AMRAP</option>
              <option value="EMOM">EMOM</option>
              <option value="FOR TIME">FOR TIME</option>
              <option value="STANDARD">STANDARD</option>
              <option value="WARM UP">WARM UP</option>
              <option value="RESISTANCE">RESISTANCE</option>
              <option value="CUSTOM">CUSTOM</option>
            </select>
          </div>
        </div>

        {/* Schedule Type Selection */}
        <div className="pw_schedule-container">
          <label className="pw_schedule-label">Workout Schedule Type</label>
          <div className="pw_schedule-options">
            <div 
              className={`pw_schedule-option ${scheduleType === 'fixed' ? 'pw_active' : ''}`}
              onClick={() => handleScheduleTypeChange('fixed')}
            >
              <div className="pw_schedule-option-title">Fixed Date Workout</div>
              <div className="pw_schedule-option-desc">
                One-time workout scheduled for a specific date
              </div>
            </div>
            <div 
              className={`pw_schedule-option ${scheduleType === 'recurring' ? 'pw_active' : ''}`}
              onClick={() => handleScheduleTypeChange('recurring')}
            >
              <div className="pw_schedule-option-title">Recurring Workout</div>
              <div className="pw_schedule-option-desc">
                Repeated workout with weekly schedule and multiple days
              </div>
            </div>
          </div>
          <div className="pw_schedule-info">
            <p className="pw_schedule-info-text">
              {scheduleType === 'fixed' 
                ? "Fixed Date: Perfect for special events, challenges, or one-time sessions. You only need to set a single workout date."
                : "Recurring: Ideal for ongoing programs, weekly routines, and structured training plans. Set week numbers, multiple days, and date ranges."
              }
            </p>
          </div>
        </div>

        {/* Conditional Fields Based on Schedule Type */}
        {scheduleType === 'fixed' ? (
          // Fixed Date Workout - Only Start Date
          <div className="pw_form-row">
            <div className="pw_form-group">
              <label className="pw_form-label">Workout Date</label>
              <input
                type="date"
                name="start_date"
                className="pw_form-input"
                value={workoutData.start_date}
                onChange={handleInputChange}
              />
            </div>
          </div>
        ) : (
          // Recurring Workout - Week, Days, Start/End Date
          <>
            {/* <div className="pw_form-row">
              <div className="pw_form-group">
                <label className="pw_form-label">Week</label>
                <select
                  name="week"
                  value={workoutData.week}
                  className="pw_form-select"
                  onChange={handleInputChange}
                >
                  <option value="">Select week...</option>
                  {weeks?.map((wk) => (
                    <option key={wk} value={wk}>Week {wk}</option>
                  ))}
                </select>
              </div>
            </div> */}

            <div className="pw_form-row">
              <div className="pw_form-group">
                <label className="pw_form-label">Start Date</label>
                <input
                  type="date"
                  name="start_date"
                  className="pw_form-input"
                  value={workoutData.start_date}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="pw_form-group">
                <label className="pw_form-label">End Date</label>
                <input
                  type="date"
                  name="end_date"
                  className="pw_form-input"
                  value={workoutData.end_date}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Days of Week - Only for Recurring */}
            <div className="pw_days-container">
              <label className="pw_days-label">Select Workout Days</label>
              <div className="pw_days-grid">
                {buttons.map((button) => (
                  <button
                    key={button.id}
                    type="button"
                    className={`pw_day-button ${
                      selectedDays?.includes(button.value) ? "pw_active" : ""
                    }`}
                    onClick={() => handleDayClick(button.value)}
                  >
                    {button.label}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}

        {/* Video Link */}
        <div className="pw_form-row">
          <div className="pw_form-group pw_form-group-full">
            <label className="pw_form-label">Video Link</label>
            <span className="pw_upload-help">
              If you already have a video link, you can add it here
            </span>
            <input
              type="url"
              className="pw_form-input"
              name="video"
              value={workoutData.video && workoutData.video.includes('firebasestorage.googleapis.com') ? '' : workoutData.video}
              onChange={handleInputChange}
              placeholder="https://youtube.com/watch?v=..."
            />
          </div>
        </div>

        {/* Media Upload Section */}
        <div className="pw_media-container">
          {/* Image Upload */}
          <div className={`pw_upload-container ${image || selectedimage ? 'pw_has-media' : ''}`}>
            <label className="pw_upload-label">Workout Banner</label>
            <input
              type="file"
              onChange={handleImageFileChange}
              className="pw_file-input"
              accept="image/*"
            />
            
            {!image && !selectedimage ? (
              <>
                <div className="pw_upload-icon">
                  <i className="fa fa-image"></i>
                </div>
                <div className="pw_upload-text">Upload Banner Image</div>
                <div className="pw_upload-subtext">
                  Click to select a beautiful banner for your workout
                </div>
              </>
            ) : (
              <>
                <img 
                  src={image ? getImageUrl(image, BASE_URL_MEDIA) : selectedimage} 
                  alt="Workout banner"
                  className="pw_media-preview"
                />
                <div className="pw_upload-subtext">
                  Click to change image
                </div>
              </>
            )}
          </div>

          {/* Video Upload */}
          <div className={`pw_upload-container ${selectedVideoUrl || workoutData.video ? 'pw_has-media' : ''}`}>
            <label className="pw_upload-label">Workout Video</label>
            <span className="pw_upload-help">
              Upload a video or use the link field above
            </span>
            
            {(selectedVideoUrl || workoutData.video) && (
              <button
                type="button"
                className="pw_change-btn"
                onClick={handleDivClick}
                title="Change video"
              >
                <i className="fa fa-pencil"></i>
              </button>
            )}
            
            <div onClick={handleDivClick} style={{ cursor: 'pointer' }}>
              <input
                ref={fileInputRef}
                type="file"
                accept="video/*"
                style={{ display: 'none' }}
                onChange={(e) => {
                  console.log("INPUT CHANGE TRIGGERED", e.target.files);
                  handleSelectVideo(e);
                }}
              />
              
              {!selectedVideoUrl && !workoutData.video ? (
                <>
                  <div className="pw_upload-icon">
                    <i className="fa fa-video-camera"></i>
                  </div>
                  <div className="pw_upload-text">Upload Video</div>
                  <div className="pw_upload-subtext">
                    Click to select a workout demonstration video
                  </div>
                </>
              ) : selectedVideoUrl ? (
                <>
                  <video 
                    className="pw_video-preview" 
                    controls 
                    src={selectedVideoUrl}
                  />
                  <div className="pw_upload-subtext">
                    Click to change video
                  </div>
                </>
              ) : (
                <>
                  {workoutData.video && !(workoutData.video.includes('youtube.com') || workoutData.video.includes('youtu.be')) && (
                    <video 
                      className="pw_video-preview" 
                      controls 
                      src={workoutData.video}
                    />
                  )}
                  <div className="pw_upload-subtext">
                    Click to change video
                  </div>
                </>
              )}
              
              {isUpLoading && (
                <div className="pw_upload-progress">
                  <div 
                    className="pw_progress-bar"
                    style={{ width: `${Math.round(progress)}%` }}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="pw_form-row">
          <div className="pw_form-group pw_form-group-full">
            <label className="pw_form-label">Description</label>
            <textarea
              name="desc"
              className="pw_form-textarea"
              value={workoutData.desc}
              onChange={handleInputChange}
              placeholder="Describe your workout, include instructions, tips, or motivation..."
              rows={6}
            />
          </div>
        </div>
        
        {/* Submit Button */}
        <div className="pw_actions-container">
          {isdisable && !wid ? (
            <button
              type="button"
              className="pw_submit-btn"
              onClick={() => CreateWork({...workoutData, schedule_type: scheduleType})}
            >
              <i className="fa fa-plus-circle" style={{ marginRight: '8px' }}></i>
              Create Workout
            </button>
          ) : (
            <button
              type="button"
              className="pw_update-btn"
              onClick={() => EditWork({...workoutData, schedule_type: scheduleType})}
            >
              <i className="fa fa-save" style={{ marginRight: '8px' }}></i>
              Update Workout
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorkoutForm;
